/* Inline Design Lab for apparel blanks. Gildan 64000 is the measured
   photo and the only style with sleeve templates. Other blanks use their
   own color photos and size chart, with the 64000 body chart as fallback.
   The print area is invisible: no dashed box or outline.
   Size caps and the default position still use that area.
   The preview is an approximate size and location. Product photos vary,
   so there is no inch grid, preview-size menu, width field, or size
   preset. Dragging the art writes the print size. Changing the
   W × H fields resizes that art on the preview. The mockup uses
   Medium when that size is offered, so a fixed print looks larger on
   a smaller shirt.
   Uploaded art can sit partly or fully outside it.
   The location drop zone is the only upload. That file feeds this
   preview and the order attachment. No second file input, and no
   text or clipart tools.
   Youth XS full-print width is 10.5 in: Gildan 64000B flat chest is 14 in,
   and the printable width is that chest minus 1.75 in on each side.
   Chest, sleeve, and nape use the location sizes in ezink-artwork-upload.js.
   Tees and long-sleeve shirts share the Gildan 64000 left and right
   sleeve templates. A side or quarter photo stays in the gallery.
   The template is tinted with the swatch hex (multiply) and marked
   Approximate. A Gildan 64000 color name uses that style's hex list.
   Any other color uses the hex stored when that front photo was
   ingested. If the swatch has no hex yet, the editor samples a few
   pixels at the center of the front photo. The sleeve files are
   Shopify Files, never product-gallery images. Other garments still
   use a real side photo when that color has one. */
(function (root) {
  var HANDLE = "gildan-64000-unisex-softstyle-tee";
  var SIDE_MARGIN = 1.75;
  var VERTICAL_RESERVE = 8;
  var TORSO_FRAC = 0.48;
  /* Gildan 64000 XS flat chest is 16 in. Across the mannequin photo,
     sleeves excluded, that body measures 9 in. The same 9/16 ratio
     applies to every size's chest width from the spec sheet or the
     product size chart. */
  var PHOTO_CHEST_RATIO = 9 / 16;
  var PROOF_LABEL = "Approximate mockup - not a final proof";
  var APPROX_NOTE = "This shows an approximate size and location. Product photos vary, so the preview is not an exact measurement.";
  var SLEEVE_TEMPLATE_NOTE = "This sleeve template is not the actual product. Use it only for positioning and sizing. Existing designs such as camo, tie-dye, and raglan (split color) are not shown.";
  var MIN_DPI = 150;
  /* Flat chest (laid flat, one inch below the armhole) and body length at
     the back, in inches. Adult rows are the Gildan published 64000 spec
     sheet (XS 16×27 through 5XL 32×35). Youth rows are the Gildan published
     64000B spec sheet (XS chest 14, length 18). ezink.size_chart on the
     page replaces these when it has a chest-width row. Full front and back
     print areas follow that chest and length. They are not capped, so 5XL
     is larger than M. */
  var SPEC_SOURCE = "Gildan published 64000 spec sheet (chest laid flat, body length at back) and 64000B youth sheet";
  var SIZE_ORDER = ["YXS", "YS", "YM", "YL", "YXL", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
  var CHART = null;

  var BODY = {
    YXS: { w: 14, len: 18, label: "Youth XS" },
    YS: { w: 16, len: 20.5, label: "Youth S" },
    YM: { w: 17, len: 22, label: "Youth M" },
    YL: { w: 18, len: 23.5, label: "Youth L" },
    YXL: { w: 19, len: 25, label: "Youth XL" },
    XS: { w: 16, len: 27, label: "XS" },
    S: { w: 18, len: 28, label: "S" },
    M: { w: 20, len: 29, label: "M" },
    L: { w: 22, len: 30, label: "L" },
    XL: { w: 24, len: 31, label: "XL" },
    "2XL": { w: 26, len: 32, label: "2XL" },
    "3XL": { w: 28, len: 33, label: "3XL" },
    "4XL": { w: 30, len: 34, label: "4XL" },
    "5XL": { w: 32, len: 35, label: "5XL" }
  };

  var FIXED = {
    "left chest": { w: 4, h: 4, view: "front", anchor: "left-chest" },
    "right chest": { w: 4, h: 4, view: "front", anchor: "right-chest" },
    "left sleeve": { w: 2.5, h: 2.5, view: "side", anchor: "left-sleeve" },
    "right sleeve": { w: 2.5, h: 2.5, view: "side", anchor: "right-sleeve" },
    nape: { w: 2.5, h: 2.5, view: "back", anchor: "nape" }
  };

  var ANCHOR = {
    front: { cx: 50, top: 23 },
    back: { cx: 50, top: 16 },
    "left-chest": { cx: 62, top: 24 },
    "right-chest": { cx: 38, top: 24 },
    "left-sleeve": { cx: 84, top: 30 },
    "right-sleeve": { cx: 16, top: 30 },
    nape: { cx: 50, top: 12 }
  };


  /* Per-style sleeve fallback. Photo placement is for this style's real
     side shots (3/4 view, both sleeves). Template placement is the neutral
     profile file. shadeMid is the flat-fabric grey the multiply uses. */
  var SLEEVE_STYLES = {
    "gildan-64000-unisex-softstyle-tee": {
      shadeMid: 208,
      colors: {
      "antique cherry red": "#a51631",
      "antique heliconia": "#bd4482",
      "antique sapphire": "#016a91",
      "azalea": "#fc89a5",
      "black": "#28292d",
      "cardinal red": "#971c34",
      "carolina blue": "#96b6e6",
      "charcoal": "#666666",
      "cherry red": "#b61d3f",
      "coral silk": "#fc7673",
      "cornsilk": "#dad185",
      "daisy": "#feca34",
      "dark chocolate": "#4c4240",
      "dark heather": "#5f6b6b",
      "fan candy pink": "#f5aeca",
      "fan dark green": "#1f4032",
      "fan deep royal": "#152e72",
      "fan marine green": "#0b4547",
      "fan texas orange": "#a6502e",
      "forest": "#2c4035",
      "garnet": "#731f2f",
      "gold": "#febd22",
      "graphite heather": "#959096",
      "heather berry": "#dd6d9f",
      "heather cardinal red": "#d36b7a",
      "heather dark grey": "#676767",
      "heather galapagos blue": "#42a4b8",
      "heather heliconia": "#fb75a3",
      "heather indigo": "#838cac",
      "heather irish green": "#049d6a",
      "heather maroon": "#805a65",
      "heather military green": "#8e8e7c",
      "heather navy": "#5d6071",
      "heather oatmeal": "#ded3c3",
      "heather orange": "#fc805f",
      "heather purple": "#6f5e92",
      "heather radiant orchid": "#e298c6",
      "heather red": "#e04f65",
      "heather royal": "#729bdd",
      "heather sapphire": "#4ba8c8",
      "heliconia": "#cd5092",
      "ice grey": "#e3d9d8",
      "indigo blue": "#5f7a94",
      "iris": "#558cc8",
      "irish green": "#049d60",
      "jade dome": "#01a3ac",
      "kelly green": "#00b98d",
      "kiwi": "#94b46c",
      "light blue": "#c7dced",
      "light pink": "#f8cccf",
      "lime": "#a2e273",
      "maroon": "#632435",
      "metro blue": "#4e5989",
      "military green": "#636250",
      "mint green": "#bae8bd",
      "natural": "#e1d2bf",
      "navy": "#273046",
      "neon blue": "#005daa",
      "off white": "#efecdf",
      "orange": "#fd6f4c",
      "paragon": "#bfa1ad",
      "pistachio": "#d1deba",
      "prairie dust": "#95876d",
      "purple": "#492a6e",
      "red": "#c9182e",
      "royal": "#2267cb",
      "sage": "#abb8a4",
      "sand": "#cdbdae",
      "sapphire": "#0192be",
      "sky": "#b6e5f7",
      "sport grey": "#acacae",
      "stone blue": "#9eafbf",
      "tropical blue": "#198796",
      "turf green": "#037c49",
      "white": "#f5f5f7"
      },
      photo: {
        bodyFrac: 0.91,
        imgW: 500,
        imgH: 625,
        left: { cx: 79, cy: 27 },
        right: { cx: 16, cy: 27 }
      },
      left: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-64000-left-sleeve-template.png?v=1792564615",
        cx: 62,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      },
      right: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-64000-right-sleeve-template.png?v=1792564618",
        cx: 38,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      }
    },
    "ezink-polo-sleeve": {
      shadeMid: 208,
      left: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-polo-left-sleeve-template_207c6951-90e3-4095-9e17-fd47add43762.png?v=1792768160",
        cx: 62,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      },
      right: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-polo-right-sleeve-template_37e7cca0-fcfb-4907-ac42-00c6fc456d2b.png?v=1792768161",
        cx: 38,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      }
    },
    "ezink-hoodie-sleeve": {
      shadeMid: 208,
      left: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-hoodie-left-sleeve-template_d570395b-1f91-40a6-a043-fba14a076f11.png?v=1792768162",
        cx: 62,
        cy: 30,
        bodyFrac: 0.914,
        imgW: 864,
        imgH: 1152
      },
      right: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-hoodie-right-sleeve-template_b3925f07-0166-4e22-af51-6550a97a173b.png?v=1792768163",
        cx: 38,
        cy: 30,
        bodyFrac: 0.914,
        imgW: 864,
        imgH: 1152
      }
    }
  };

  var FAMILY_STYLE = {
    tee: HANDLE,
    "long-sleeve": HANDLE,
    polo: "ezink-polo-sleeve",
    hoodie: "ezink-hoodie-sleeve"
  };

  function parseHex(hex) {
    var h = String(hex || "").replace("#", "").trim();
    if (h.length === 3) h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function clamp255(n) {
    n = Math.round(Number(n) || 0);
    if (n < 0) return 0;
    if (n > 255) return 255;
    return n;
  }

  /* Multiply the light-grey shading by the swatch. grey 208 is the flat fabric. */
  function tintChannels(grey, hex, mid) {
    var rgb = parseHex(hex);
    if (!rgb) return null;
    var f = Number(grey) / (Number(mid) || 208);
    return [clamp255(rgb[0] * f), clamp255(rgb[1] * f), clamp255(rgb[2] * f)];
  }

  function swatchHex(handle, color) {
    var style = SLEEVE_STYLES[handle];
    if (!style || !style.colors) return "";
    return style.colors[String(color || "").trim().toLowerCase()] || "";
  }

  function hexByte(n) {
    var s = clamp255(n).toString(16);
    return s.length === 1 ? "0" + s : s;
  }

  /* Average a small square at the middle of an RGBA buffer. Transparent
     pixels are skipped. span is the window width in pixels. */
  function centerAverageHex(data, width, height, span) {
    width = width | 0;
    height = height | 0;
    span = span || 9;
    if (!data || width < 1 || height < 1) return "";
    var sw = Math.min(span, width);
    var sh = Math.min(span, height);
    var x0 = Math.floor((width - sw) / 2);
    var y0 = Math.floor((height - sh) / 2);
    var r = 0;
    var g = 0;
    var b = 0;
    var n = 0;
    var y;
    var x;
    var i;
    for (y = 0; y < sh; y++) {
      for (x = 0; x < sw; x++) {
        i = ((y0 + y) * width + (x0 + x)) * 4;
        if (data[i + 3] < 8) continue;
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        n += 1;
      }
    }
    if (!n) return "";
    return "#" + hexByte(r / n) + hexByte(g / n) + hexByte(b / n);
  }

  function isSleeveView(view, side) {
    var v = String(view || "").toLowerCase().trim();
    if (!v || v.indexOf("front") === 0 || v.indexOf("back") === 0 || v.indexOf("on-model") >= 0) return false;
    if (v.indexOf("sleeve") < 0 && v !== "side" && v.indexOf("side") !== 0) return false;
    if (side === "left" && v.indexOf("right") === 0) return false;
    if (side === "right" && v.indexOf("left") === 0) return false;
    return true;
  }

  /* Tees and long-sleeve shirts share the 64000 sleeve drawings.
     Polos and hoodies each have their own pair. Other garments stay on photos. */
  function sleeveFamily(tags, handle) {
    if (tagHas(tags, "category:hoodie") || tagHas(tags, "garment:hoodie") || tagHas(tags, "garment:cropped-hoodie")) return "hoodie";
    if (tagHas(tags, "category:polo") || tagHas(tags, "garment:polo")) return "polo";
    if (tagHas(tags, "category:long-sleeve") || tagHas(tags, "garment:long-sleeve")) return "long-sleeve";
    if (tagHas(tags, "category:t-shirt") || tagHas(tags, "garment:tee")) return "tee";
    if (handle === HANDLE) return "tee";
    return "";
  }

  function chooseSleeve(handle, side, views, tags) {
    var family = sleeveFamily(tags, handle);
    var sharedKey = FAMILY_STYLE[family] || "";
    if (sharedKey) {
      var shared = SLEEVE_STYLES[sharedKey];
      if (shared && shared[side] && shared[side].url) return { kind: "template", side: side, style: sharedKey };
      return { kind: "none" };
    }
    var named = "";
    var generic = "";
    var list = views || [];
    var i;
    for (i = 0; i < list.length; i++) {
      var v = String(list[i] || "").toLowerCase();
      if (!isSleeveView(v, side)) continue;
      if (v.indexOf(side) >= 0) named = v;
      else if (!generic) generic = v;
    }
    if (named || generic) return { kind: "photo", view: named || generic };
    var style = SLEEVE_STYLES[handle];
    if (style && style[side] && style[side].url) return { kind: "template", side: side, style: handle };
    return { kind: "none" };
  }

  function sleeveGeom(handle, side, kind) {
    var style = SLEEVE_STYLES[handle];
    if (!style) return null;
    if (kind === "photo" && style.photo && style.photo[side]) {
      return {
        cx: style.photo[side].cx,
        cy: style.photo[side].cy,
        bodyFrac: style.photo.bodyFrac,
        imgW: style.photo.imgW,
        imgH: style.photo.imgH
      };
    }
    var tmpl = style[side];
    if (kind === "template" && tmpl) {
      return {
        cx: tmpl.cx,
        cy: tmpl.cy,
        bodyFrac: tmpl.bodyFrac,
        imgW: tmpl.imgW,
        imgH: tmpl.imgH
      };
    }
    return null;
  }

  /* Box is  area inches tall on a photo whose garment height is body length. */
  function sleeveBox(size, areaW, areaH, geom) {
    var body = bodyFor(size);
    var widthPct = (areaW / body.len) * geom.bodyFrac * (geom.imgH / geom.imgW) * 100;
    var heightPct = (areaH / body.len) * geom.bodyFrac * 100;
    return {
      widthPct: widthPct,
      left: geom.cx - widthPct / 2,
      top: geom.cy - heightPct / 2
    };
  }

  function roundIn(n) {
    return Math.round((Number(n) + 1e-9) * 10) / 10;
  }

  function normalizeSize(raw, youthProduct) {
    return knownSize(raw, youthProduct) || (youthProduct ? "YXS" : "M");
  }

  function locKey(name) {
    var s = String(name || "front").toLowerCase().replace(/\s+\d+$/, "").trim();
    if (s === "full front" || s === "center front" || s === "front") return "front";
    if (s === "full back" || s === "back") return "back";
    if (s === "left chest" || s === "lc") return "left chest";
    if (s === "right chest" || s === "rc") return "right chest";
    if (s === "left sleeve") return "left sleeve";
    if (s === "right sleeve") return "right sleeve";
    if (s === "nape" || s === "yoke") return "nape";
    return "other";
  }

  function garmentMaxWidth(body) {
    return roundIn(Math.max(2, body.w - SIDE_MARGIN * 2));
  }

  function heightRoom(body, cap) {
    var room = Math.max(6, body.len - VERTICAL_RESERVE);
    if (cap > 0) room = Math.min(cap, room);
    return roundIn(room);
  }

  function printArea(sizeRaw, location, opts) {
    opts = opts || {};
    var size = normalizeSize(sizeRaw, !!opts.youth);
    var body = bodyFor(size);
    var maxW = garmentMaxWidth(body);
    var key = locKey(location);
    var fixed = FIXED[key];
    if (fixed) {
      var w = fixed.w;
      var h = fixed.h;
      if (w > maxW) {
        h = roundIn(h * (maxW / w));
        w = maxW;
      }
      return {
        w: w,
        h: h,
        view: fixed.view,
        anchor: fixed.anchor,
        size: size,
        sizeLabel: body.label,
        key: key
      };
    }
    var view = key === "back" ? "back" : "front";
    var anchor = key === "back" ? "back" : "front";
    var width = key === "other" ? roundIn(Math.min(8, maxW)) : maxW;
    var height = heightRoom(body, key === "other" ? 8 : 0);
    if (key === "other") height = roundIn(Math.min(height, width));
    return {
      w: width,
      h: height,
      view: view,
      anchor: anchor,
      size: size,
      sizeLabel: body.label,
      key: key
    };
  }

  function clampPlacement(boxW, boxH, natW, natH, x, y, wPct, freeSize) {
    if (!(natW > 0) || !(natH > 0) || !(boxW > 0) || !(boxH > 0)) {
      return { x: 50, y: 50, wPct: 70 };
    }
    var aspect = natW / natH;
    var wpx = (wPct / 100) * boxW;
    var hpx = wpx / aspect;
    /* Sleeve art has no size ceiling. Other locations stay inside the print box. */
    if (!freeSize) {
      if (hpx > boxH) {
        hpx = boxH;
        wpx = hpx * aspect;
      }
      if (wpx > boxW) {
        wpx = boxW;
        hpx = wpx / aspect;
      }
    }
    var minW = Math.min(boxW, boxH * aspect) * 0.08;
    if (wpx < minW) {
      wpx = minW;
      hpx = wpx / aspect;
      if (!freeSize && hpx > boxH) {
        hpx = boxH;
        wpx = hpx * aspect;
      }
    }
    /* x and y are not pulled back into the print area. Placement stays free. */
    return {
      x: x,
      y: y,
      wPct: (wpx / boxW) * 100
    };
  }

  function widthInches(wPct, areaW) {
    return roundIn((wPct / 100) * areaW);
  }

  function chartEntry(size) {
    if (!CHART) return null;
    if (CHART[size]) return CHART[size];
    var adult = { YXS: "XS", YS: "S", YM: "M", YL: "L", YXL: "XL" }[size];
    if (!adult || !CHART[adult]) return null;
    if (CHART["2XL"] || CHART["5XL"]) return null;
    var row = CHART[adult];
    if (!(row.w > 0)) return null;
    if (size === "YXS" && row.w > 15.5) return null;
    return row;
  }

  function bodyFor(size) {
    var key = BODY[size] ? size : "M";
    var base = BODY[key];
    var over = chartEntry(key);
    if (!over) return base;
    return {
      w: over.w > 0 ? over.w : base.w,
      len: over.len > 0 ? over.len : base.len,
      label: base.label || over.label
    };
  }

  function knownSize(raw, youthProduct) {
    var s = String(raw || "").trim().toUpperCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (!s || s === "SIZE") return "";
    if (s === "YOUTH XS" || s === "YOUTH XSMALL" || s === "YOUTH X SMALL" || s === "YOUTH EXTRA SMALL" || s === "YXS" || s === "YS XS") return "YXS";
    if (s === "YOUTH S" || s === "YOUTH SMALL" || s === "YS") return "YS";
    if (s === "YOUTH M" || s === "YOUTH MEDIUM" || s === "YM") return "YM";
    if (s === "YOUTH L" || s === "YOUTH LARGE" || s === "YL") return "YL";
    if (s === "YOUTH XL" || s === "YOUTH XLARGE" || s === "YOUTH X LARGE" || s === "YXL") return "YXL";
    if (s === "XXL" || s === "2X") return "2XL";
    if (s === "XXXL" || s === "3X") return "3XL";
    if (s === "4X") return "4XL";
    if (s === "5X") return "5XL";
    if (s === "XSMALL" || s === "X SMALL" || s === "EXTRA SMALL") s = "XS";
    if (s === "SMALL") s = "S";
    if (s === "MEDIUM") s = "M";
    if (s === "LARGE") s = "L";
    if (s === "XLARGE" || s === "X LARGE" || s === "EXTRA LARGE") s = "XL";
    if (youthProduct) {
      if (s === "XS") return "YXS";
      if (s === "S") return "YS";
      if (s === "M") return "YM";
      if (s === "L") return "YL";
      if (s === "XL") return "YXL";
    }
    if (BODY[s]) return s;
    return "";
  }

  function parseInches(raw) {
    var s = String(raw == null ? "" : raw).replace(/["″]/g, "").trim();
    var mixed = s.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)/);
    if (mixed) return Number(mixed[1]) + Number(mixed[2]) / Number(mixed[3]);
    var frac = s.match(/^(\d+)\s*\/\s*(\d+)/);
    if (frac) return Number(frac[1]) / Number(frac[2]);
    var n = parseFloat(s);
    return n > 0 ? n : 0;
  }

  /* Chest rows are not all the same measurement. "Chest Width (Laid Flat)"
     is already the flat width. "Chest Circumference" (Adidas A2016 and
     similar) is the full around measurement, so it is stored as half of
     that. Waist and crown circumference are not chest. */
  function specKind(name) {
    var s = String(name || "").toLowerCase().replace(/\s+/g, " ").trim();
    if (!s || /sleeve|shoulder|neck|collar|hem|tolerance/.test(s)) return "";
    var around = /circum|girth|\baround\b|all around/.test(s);
    var flat = /laid flat|body width/.test(s);
    var chest = /chest|bust/.test(s) || flat;
    if (chest && around && !flat) return "circ";
    if (chest) return "w";
    if (/body length|^length\b|length at back/.test(s)) return "len";
    return "";
  }

  function parseSizeChart(headers, rows) {
    if (!headers || headers.length < 2 || !rows || !rows.length) return null;
    var widthRow = null;
    var circRow = null;
    var lenRow = null;
    var i;
    for (i = 0; i < rows.length; i++) {
      var kind = specKind(rows[i] && rows[i][0]);
      if (kind === "w" && !widthRow) widthRow = rows[i];
      if (kind === "circ" && !circRow) circRow = rows[i];
      if (kind === "len" && !lenRow) lenRow = rows[i];
    }
    var useCirc = !widthRow && !!circRow;
    var measureRow = widthRow || circRow;
    if (!measureRow) return null;
    var out = {};
    var found = false;
    for (i = 1; i < headers.length; i++) {
      var size = knownSize(headers[i], false);
      if (!size) size = knownSize(headers[i], true);
      if (!size || out[size]) continue;
      var w = parseInches(measureRow[i]);
      if (useCirc) w = w / 2;
      if (!(w > 0)) continue;
      var len = lenRow ? parseInches(lenRow[i]) : 0;
      var base = BODY[size];
      out[size] = {
        w: w,
        len: len > 0 ? len : (base ? base.len : 0),
        label: base ? base.label : String(headers[i])
      };
      found = true;
    }
    return found ? out : null;
  }

  function applySpecChart(headers, rows) {
    CHART = parseSizeChart(headers, rows);
    return CHART;
  }

  function clearSpecChart() {
    CHART = null;
  }

  function specSource() {
    return CHART ? "product size chart" : SPEC_SOURCE;
  }

  function offeredSizes(labels, youthProduct) {
    var seen = {};
    var i;
    for (i = 0; i < (labels || []).length; i++) {
      var size = knownSize(labels[i], !!youthProduct);
      if (size) seen[size] = true;
    }
    return SIZE_ORDER.filter(function (s) { return seen[s]; });
  }

  function defaultPreviewSize(sizes) {
    var list = sizes || [];
    if (list.indexOf("M") >= 0) return "M";
    if (list.indexOf("YM") >= 0) return "YM";
    return list.length ? list[0] : "M";
  }

  function referenceWidth(sizes) {
    var list = sizes && sizes.length ? sizes : ["5XL"];
    var max = 0;
    var i;
    for (i = 0; i < list.length; i++) {
      var body = bodyFor(list[i]);
      if (body && body.w > max) max = body.w;
    }
    return max || bodyFor("M").w;
  }

  /* Inches across the visible body in a front or back photo. */
  function photoChest(body) {
    var flat = body && body.w > 0 ? body.w : 0;
    if (!(flat > 0)) return 0;
    return flat * PHOTO_CHEST_RATIO;
  }

  /* Chest pixels on the mockup divided by the flat chest width. */
  function pixelsPerInch(photoWidthPx, bodyWidthIn, torsoFrac) {
    var frac = torsoFrac == null ? TORSO_FRAC : torsoFrac;
    if (!(photoWidthPx > 0) || !(bodyWidthIn > 0) || !(frac > 0)) return 0;
    return (photoWidthPx * frac) / bodyWidthIn;
  }

  function artPixels(inches, ppi) {
    return (Number(inches) || 0) * (Number(ppi) || 0);
  }

  function coverage(artInches, bodyWidthIn) {
    if (!(bodyWidthIn > 0)) return 0;
    return (Number(artInches) || 0) / bodyWidthIn;
  }

  /* Garment drawing scale against the widest offered size, at a fixed PPI. */
  function shirtScale(bodyW, refW) {
    if (!(bodyW > 0) || !(refW > 0)) return 1;
    return bodyW / refW;
  }

  function fitInches(inchW, natW, natH, maxW, maxH) {
    var aspect = natW > 0 && natH > 0 ? natW / natH : 1;
    var w = Number(inchW);
    if (!(w > 0) || w < 0.5) w = 0.5;
    var h = w / aspect;
    if (maxW > 0 && w > maxW) {
      w = maxW;
      h = w / aspect;
    }
    if (maxH > 0 && h > maxH) {
      h = maxH;
      w = h * aspect;
    }
    if (maxW > 0 && w > maxW) w = maxW;
    return { w: roundIn(w), h: roundIn(h) };
  }

  /* Width drives the preview. A height edit is converted through the
     artwork aspect. An empty or unfinished value returns 0 so the
     current art size stays put. */
  function inchesFromSizeFields(widthIn, heightIn, which, natW, natH) {
    var w = Number(widthIn);
    var h = Number(heightIn);
    var aspect = natW > 0 && natH > 0 ? natW / natH : 0;
    if (which === "h") {
      if (h > 0 && aspect > 0) return h * aspect;
      if (w > 0) return w;
      return 0;
    }
    if (w > 0) return w;
    if (h > 0 && aspect > 0) return h * aspect;
    return 0;
  }

  /* roundIn maps 8.25 to 8.3. The spinner's down step used to land on
     .25 and .75, then the field was written back to the old tenth, so
     down did nothing while up stuck. A user edit keeps the lower size. */
  function preserveSpinnerInches(typed, fitted) {
    var n = Number(typed);
    var w = Number(fitted);
    if (!(n > 0) || !(w > 0)) return w;
    if (w > n + 1e-6) return n;
    return w;
  }

  /* Keep a focused field's text when it is the same size, so "10." is
     not rewritten to "10" mid-keystroke. A different size is replaced. */
  function keepTypedInches(raw, fitted, formatted) {
    var text = String(raw == null ? "" : raw).trim();
    var n = parseFloat(text);
    if (!(n > 0)) return false;
    if (Math.abs(n - Number(fitted)) > 1e-6) return false;
    return text !== String(formatted);
  }

  function rasterDpi(px, inches) {
    if (!(px > 0) || !(inches > 0)) return 0;
    return px / inches;
  }

  function lowResWarning(px, inches, isVector, minDpi) {
    if (isVector) return "";
    var floor = minDpi || MIN_DPI;
    var dpi = rasterDpi(px, inches);
    if (!(dpi > 0) || dpi + 1e-9 >= floor) return "";
    return "Low resolution: about " + Math.round(dpi) + " DPI at this print size. Aim for " + floor + " DPI or higher.";
  }

  function shouldWarp(key) {
    return key !== "left sleeve" && key !== "right sleeve";
  }

  /* Half-angle of a mild chest cylinder. Small prints return 0. */
  function warpTheta(artW, bodyW) {
    if (!(artW > 0) || !(bodyW > 0)) return 0;
    var radius = bodyW / Math.PI;
    var theta = (artW / 2) / radius;
    if (theta > 1.15) theta = 1.15;
    if (theta < 0.15) return 0;
    return theta;
  }

  /* 1 = flat. Lower means the print's edges pull in. Half of a true cylinder. */
  function edgeSqueeze(theta) {
    var t = Number(theta) || 0;
    if (!(t > 0)) return 1;
    var full = Math.sin(t) / t;
    return 1 - (1 - full) * 0.5;
  }

  function chestWarpNorm(norm, theta) {
    var t = Number(theta) || 0;
    var n = Number(norm) || 0;
    if (n > 1) n = 1;
    if (n < -1) n = -1;
    if (!(t > 0)) return n;
    var s = Math.sin(t);
    if (!(s > 0)) return n;
    return Math.sin(n * t) / s;
  }

  function chestUnwarpNorm(norm, theta) {
    var t = Number(theta) || 0;
    var n = Number(norm) || 0;
    if (n > 1) n = 1;
    if (n < -1) n = -1;
    if (!(t > 0)) return n;
    var s = Math.sin(t);
    if (!(s > 0)) return n;
    var arg = n * s;
    if (arg > 1) arg = 1;
    if (arg < -1) arg = -1;
    return Math.asin(arg) / t;
  }

  function garmentCenterX(sizeRaw, location, opts) {
    var area = printArea(sizeRaw, location, opts);
    if (area.key.indexOf("sleeve") >= 0) return 50;
    var anchor = ANCHOR[area.anchor] || ANCHOR.front;
    var body = bodyFor(area.size);
    var chest = photoChest(body) || body.w;
    var widthPct = (area.w / chest) * TORSO_FRAC * 100;
    if (!(widthPct > 0)) return 50;
    var boxLeft = anchor.cx - widthPct / 2;
    return ((50 - boxLeft) / widthPct) * 100;
  }

  function snapBandPct(areaW) {
    if (!(areaW > 0)) return 3;
    return (0.35 / areaW) * 100;
  }

  /* Lightbox long edge. The on-page garment stays at the 1200px rendition. */
  var ZOOM_LONG_EDGE = 2880;

  function shopifyZoomUrl(url, width) {
    var edge = width || ZOOM_LONG_EDGE;
    if (!url || /^(data:|blob:)/i.test(url)) return "";
    var out = String(url);
    if (out.indexOf("{width}") >= 0) return out.replace(/\{width\}/g, String(edge));
    var match = out.match(/_(\d{3,5})x(\d{0,5})?(?=\.(?:jpe?g|png|webp|gif|avif)(?:\?|#|$))/i);
    if (!match) return "";
    var currentW = Number(match[1]) || 0;
    var currentH = Number(match[2]) || 0;
    if (currentW >= edge && !(currentH > 0 && currentH < edge)) return "";
    var at = out.lastIndexOf(match[0]);
    return out.slice(0, at) + "_" + edge + "x" + out.slice(at + match[0].length);
  }

  function fitCanvasSize(nw, nh, maxEdge) {
    var w = Math.round(Number(nw) || 0);
    var h = Math.round(Number(nh) || 0);
    if (!(w > 0) || !(h > 0)) return { w: 0, h: 0 };
    var cap = Number(maxEdge) || 0;
    if (!(cap > 0) || Math.max(w, h) <= cap) return { w: w, h: h };
    var scale = cap / Math.max(w, h);
    return {
      w: Math.max(1, Math.round(w * scale)),
      h: Math.max(1, Math.round(h * scale))
    };
  }

  /* Lightbox canvas. Product photos are often ~500px, so scale up to the
     lightbox long edge and draw the artwork at that size. */
  function zoomCanvasSize(nw, nh, maxEdge) {
    var fitted = fitCanvasSize(nw, nh, maxEdge);
    if (!(fitted.w > 0) || !(fitted.h > 0)) return fitted;
    var cap = Number(maxEdge) || 0;
    if (!(cap > 0)) return fitted;
    var edge = Math.max(fitted.w, fitted.h);
    if (edge + 0.5 >= cap) return fitted;
    var scale = cap / edge;
    return {
      w: Math.max(1, Math.round(fitted.w * scale)),
      h: Math.max(1, Math.round(fitted.h * scale))
    };
  }

  function paintWarp(canvas, img, theta) {
    var w = canvas.width;
    var h = canvas.height;
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, w, h);
    var squeeze = edgeSqueeze(theta);
    var drawW = w * squeeze;
    var ox = (w - drawW) / 2;
    var strips = Math.max(24, Math.min(80, Math.round(drawW / 3)));
    var nw = img.naturalWidth || img.width;
    var nh = img.naturalHeight || img.height;
    var i;
    for (i = 0; i < strips; i++) {
      var d0 = i / strips;
      var d1 = (i + 1) / strips;
      var s0 = (chestUnwarpNorm(d0 * 2 - 1, theta) + 1) / 2;
      var s1 = (chestUnwarpNorm(d1 * 2 - 1, theta) + 1) / 2;
      var sx = s0 * nw;
      var sw = (s1 - s0) * nw;
      if (!(sw > 0)) continue;
      ctx.drawImage(img, sx, 0, sw, nh, ox + d0 * drawW, 0, (d1 - d0) * drawW, h);
    }
  }

  var api = {
    HANDLE: HANDLE,
    PROOF_LABEL: PROOF_LABEL,
    BODY: BODY,
    SLEEVE_STYLES: SLEEVE_STYLES,
    normalizeSize: normalizeSize,
    locKey: locKey,
    printArea: printArea,
    clampPlacement: clampPlacement,
    widthInches: widthInches,
    garmentMaxWidth: garmentMaxWidth,
    swatchHex: swatchHex,
    centerAverageHex: centerAverageHex,
    tintChannels: tintChannels,
    chooseSleeve: chooseSleeve,
    sleeveFamily: sleeveFamily,
    sleeveGeom: sleeveGeom,
    sleeveBox: sleeveBox,
    isSleeveView: isSleeveView,
    SPEC_SOURCE: SPEC_SOURCE,
    MIN_DPI: MIN_DPI,
    bodyFor: bodyFor,
    knownSize: knownSize,
    parseInches: parseInches,
    parseSizeChart: parseSizeChart,
    applySpecChart: applySpecChart,
    clearSpecChart: clearSpecChart,
    specSource: specSource,
    offeredSizes: offeredSizes,
    defaultPreviewSize: defaultPreviewSize,
    referenceWidth: referenceWidth,
    PHOTO_CHEST_RATIO: PHOTO_CHEST_RATIO,
    photoChest: photoChest,
    pixelsPerInch: pixelsPerInch,
    artPixels: artPixels,
    coverage: coverage,
    shirtScale: shirtScale,
    fitInches: fitInches,
    inchesFromSizeFields: inchesFromSizeFields,
    preserveSpinnerInches: preserveSpinnerInches,
    keepTypedInches: keepTypedInches,
    rasterDpi: rasterDpi,
    lowResWarning: lowResWarning,
    shouldWarp: shouldWarp,
    warpTheta: warpTheta,
    edgeSqueeze: edgeSqueeze,
    chestWarpNorm: chestWarpNorm,
    chestUnwarpNorm: chestUnwarpNorm,
    garmentCenterX: garmentCenterX,
    snapBandPct: snapBandPct,
    paintWarp: paintWarp,
    apparelSnapshot: apparelSnapshot,
    apparelSnapshotZoom: apparelSnapshotZoom,
    ZOOM_LONG_EDGE: ZOOM_LONG_EDGE,
    shopifyZoomUrl: shopifyZoomUrl,
    fitCanvasSize: fitCanvasSize,
    zoomCanvasSize: zoomCanvasSize
  };
  root.EZINKDesignLab = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (typeof document === "undefined") return;

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
  }

  function tagHas(tags, name) {
    var list = String(tags || "").toLowerCase().split(",");
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].trim() === name) return true;
    }
    return false;
  }

  function isTarget(pdp) {
    if (!pdp || !pdp.getAttribute) return false;
    var handle = pdp.getAttribute("data-ezink-handle") || "";
    if (handle === HANDLE) return true;
    if (!handle && root.location && String(root.location.pathname || "").indexOf("/products/" + HANDLE) >= 0) {
      return true;
    }
    var mode = (pdp.getAttribute("data-ezink-art-mode") || "").toLowerCase();
    if (mode === "print") return false;
    var type = (pdp.getAttribute("data-ezink-type") || "").toLowerCase();
    if (type === "apparel blanks" || tagHas(pdp.getAttribute("data-ezink-tags"), "blanks")) return true;
    return false;
  }

  function styleHandle(pdp) {
    var handle = pdp && pdp.getAttribute ? (pdp.getAttribute("data-ezink-handle") || "") : "";
    return handle || HANDLE;
  }

  function sectionOf(node) {
    var el = node;
    while (el) {
      if (el.id && el.id.indexOf("ProductSection-") === 0) return el;
      el = el.parentElement;
    }
    var pdp = node.closest ? (node.closest("[data-ezink-art-pdp]") || node) : node;
    var sib = pdp.previousElementSibling;
    var guard = 0;
    while (sib && guard < 8) {
      if (sib.id && sib.id.indexOf("ProductSection-") === 0) return sib;
      if (sib.querySelector) {
        var inner = sib.querySelector("[id^='ProductSection-']");
        if (inner) return inner;
      }
      sib = sib.previousElementSibling;
      guard += 1;
    }
    return document.querySelector("[id^='ProductSection-']");
  }

  function selectedColor(section) {
    if (!section) return "";
    var sw = section.querySelector(".ezink-pdp-swatch.is-selected");
    if (sw && sw.getAttribute("data-color")) return sw.getAttribute("data-color");
    var label = section.querySelector("[data-ezink-selected-color]");
    if (label && label.textContent.trim()) return label.textContent.trim();
    var sel = section.querySelector("[data-ezink-color-select]");
    if (sel && sel.value) return sel.value;
    return section.getAttribute("data-active-color") || "";
  }

  function imgUrl(img) {
    if (!img) return "";
    var tpl = img.getAttribute("data-src") || "";
    if (tpl.indexOf("{width}") >= 0) return tpl.replace("{width}", "1200");
    if (tpl && tpl.indexOf("{") < 0) return tpl;
    return img.currentSrc || img.getAttribute("src") || "";
  }

  function colorMedia(section, color) {
    var want = (color || "").toLowerCase();
    var nodes = section ? section.querySelectorAll("[data-product-single-media-wrapper][data-media-color]") : [];
    var views = [];
    var urls = {};
    var i;
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.getAttribute("data-media-color") || "").toLowerCase();
      if (want && c !== want) continue;
      var v = (el.getAttribute("data-media-view") || "").toLowerCase();
      var url = imgUrl(el.querySelector("img"));
      if (!url) continue;
      views.push(v);
      if (!urls[v]) urls[v] = url;
    }
    return { views: views, urls: urls };
  }

  var frontHexByUrl = {};

  function swatchForColor(section, color) {
    if (!section || !section.querySelectorAll) return null;
    var want = String(color || "").trim();
    var nodes = section.querySelectorAll(".ezink-pdp-swatch");
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (want && (nodes[i].getAttribute("data-color") || "").trim() === want) return nodes[i];
    }
    return section.querySelector(".ezink-pdp-swatch.is-selected");
  }

  function selectedHex(section, color) {
    var named = swatchHex(HANDLE, color);
    if (named) return named;
    var sw = swatchForColor(section, color);
    var fromSwatch = sw && sw.getAttribute("data-hex");
    return fromSwatch || "";
  }

  function writeSwatchHex(section, color, hex) {
    if (!hex) return;
    var sw = swatchForColor(section, color);
    if (sw) sw.setAttribute("data-hex", hex);
  }

  function absUrl(url) {
    if (!url) return "";
    if (url.indexOf("//") === 0) return "https:" + url;
    return url;
  }

  function sampleImageCenter(img) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    if (!w || !h) return "";
    var span = 9;
    var sw = Math.min(span, w);
    var sh = Math.min(span, h);
    var canvas = document.createElement("canvas");
    canvas.width = sw;
    canvas.height = sh;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(
      img,
      Math.floor((w - sw) / 2),
      Math.floor((h - sh) / 2),
      sw,
      sh,
      0,
      0,
      sw,
      sh
    );
    return centerAverageHex(ctx.getImageData(0, 0, sw, sh).data, sw, sh, span);
  }

  function tintImage(img, hex, mid) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    if (!w || !h) return "";
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h);
    var px = data.data;
    var i;
    for (i = 0; i < px.length; i += 4) {
      if (px[i + 3] < 8) continue;
      var rgb = tintChannels(px[i], hex, mid);
      if (!rgb) return "";
      px[i] = rgb[0];
      px[i + 1] = rgb[1];
      px[i + 2] = rgb[2];
    }
    ctx.putImageData(data, 0, 0);
    return canvas.toDataURL("image/png");
  }

  function pickMedia(section, color, view) {
    if (!section) return "";
    var want = (color || "").toLowerCase();
    var nodes = section.querySelectorAll("[data-product-single-media-wrapper][data-media-color]");
    var front = "";
    var any = "";
    var i;
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.getAttribute("data-media-color") || "").toLowerCase();
      if (want && c !== want) continue;
      var v = (el.getAttribute("data-media-view") || "").toLowerCase();
      var url = imgUrl(el.querySelector("img"));
      if (!url) continue;
      if (!any) any = url;
      if ((v.indexOf("front") === 0) && v.indexOf("on-model") < 0 && !front) front = url;
      if (view === "back" && v.indexOf("back") === 0) return url;
      if (view === "side" && v.indexOf("side") === 0) return url;
      if (view === "front" && v.indexOf("front") === 0 && v.indexOf("on-model") < 0) return url;
    }
    return front || any;
  }

  function tightestSize(section) {
    var best = "";
    var bestW = Infinity;
    if (!section) return "M";
    var inputs = section.querySelectorAll("[data-ezink-size-qty-input]");
    inputs.forEach(function (inp) {
      var qty = parseInt(inp.value, 10) || 0;
      if (qty < 1) return;
      var size = normalizeSize(inp.getAttribute("data-size") || "", false);
      var body = BODY[size];
      if (body && body.w < bestW) {
        bestW = body.w;
        best = size;
      }
    });
    return best || "M";
  }

  function locationName(item) {
    var labeled = item.getAttribute("data-art-label");
    if (labeled) return labeled;
    var sel = item.querySelector("[data-ezink-art-loc]");
    return (sel && sel.value) || "Front";
  }

  function fmtIn(n) {
    var v = roundIn(n);
    return (Math.abs(v - Math.round(v)) < 0.05 ? String(Math.round(v)) : v.toFixed(1));
  }

  /* ezink-dlab-modal-v2 — lightbox is on the body so it cannot outgrow the window. */
  var studio = { item: null, homeParent: null, homeNext: null, opener: null };
  var scrollLocked = false;
  var scrollLockY = 0;

  function lockScroll() {
    if (scrollLocked) return;
    scrollLocked = true;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = "-" + scrollLockY + "px";
    document.documentElement.classList.add("ezink-scroll-lock");
  }

  function unlockScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.documentElement.classList.remove("ezink-scroll-lock");
    document.body.style.top = "";
    window.scrollTo(0, scrollLockY);
  }

  function focusables(root) {
    if (!root || !root.querySelectorAll) return [];
    var nodes = root.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])");
    return Array.prototype.filter.call(nodes, function (el) {
      if (!el || el.hidden || el.getAttribute("aria-hidden") === "true") return false;
      if (el.closest && el.closest("[hidden]")) return false;
      var style = window.getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  }

  function paintArtSummary(item) {
    if (!item) return;
    var box = item.querySelector("[data-ezink-art-summary]");
    if (!box) return;
    var loc = item.getAttribute("data-art-label") || "";
    var sel = item.querySelector("[data-ezink-art-loc]");
    if (!loc && sel) loc = sel.value || "";
    var wEl = item.querySelector("[data-ezink-art-w]");
    var hEl = item.querySelector("[data-ezink-art-h]");
    var w = wEl && String(wEl.value || "").trim();
    var h = hEl && String(hEl.value || "").trim();
    var readout = item.querySelector("[data-ezink-design-readout]");
    var sizeBit = "";
    if (w && h) sizeBit = w + " × " + h + " in";
    else if (readout && String(readout.textContent || "").trim()) sizeBit = String(readout.textContent).trim();
    var typeBit = printTypeLabel(item);
    var text = [loc, sizeBit, typeBit].filter(Boolean).join(" · ");
    var label = box.querySelector("[data-ezink-art-summary-text]");
    if (label) label.textContent = text;
    paintSummaryImg(box.querySelector("[data-ezink-art-summary-img]"), studioFileSrc(item), text);
    paintWearPreview(item, box);
    box.hidden = false;
  }

  function paintSummaryImg(img, src, alt) {
    if (!img) return;
    if (src) {
      img.src = src;
      img.alt = alt || "";
      img.hidden = false;
    } else {
      img.removeAttribute("src");
      img.alt = "";
      img.hidden = true;
    }
  }

  function studioFileSrc(item) {
    if (!item || !item.querySelector) return "";
    var prev = item.querySelector("[data-ezink-drop-preview] img");
    if (prev && prev.getAttribute("src")) return prev.getAttribute("src");
    var art = item.querySelector("[data-ezink-design-art]");
    var wrap = art && art.closest("[data-ezink-design-artwrap]");
    if (art && art.getAttribute("src") && !(wrap && wrap.hidden)) return art.getAttribute("src");
    return "";
  }

  /* Garment photo and artwork only. Do not stroke the print area. */
  function apparelSnapshot(item) {
    if (!item || !item.querySelector || typeof document === "undefined") return "";
    var garment = item.querySelector("[data-ezink-design-garment]");
    var art = item.querySelector("[data-ezink-design-art]");
    var wrap = item.querySelector("[data-ezink-design-artwrap]");
    var warp = item.querySelector("[data-ezink-design-warp]");
    if (!garment || !art || !wrap) return "";
    if (wrap.hidden || !art.getAttribute("src") || !garment.naturalWidth) return "";
    try {
      var canvas = document.createElement("canvas");
      canvas.width = garment.naturalWidth;
      canvas.height = garment.naturalHeight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(garment, 0, 0, canvas.width, canvas.height);
      var gRect = garment.getBoundingClientRect();
      var visual = (wrap.classList.contains("is-warped") && warp && !warp.hidden) ? warp : art;
      var aRect = visual.getBoundingClientRect();
      if (!gRect.width || !gRect.height) return "";
      var sx = canvas.width / gRect.width;
      var sy = canvas.height / gRect.height;
      ctx.drawImage(
        visual,
        (aRect.left - gRect.left) * sx,
        (aRect.top - gRect.top) * sy,
        aRect.width * sx,
        aRect.height * sy
      );
      return canvas.toDataURL("image/png");
    } catch (err) {
      return "";
    }
  }

  function snapshotLayout(item) {
    if (!item || !item.querySelector || typeof document === "undefined") return null;
    var garment = item.querySelector("[data-ezink-design-garment]");
    var art = item.querySelector("[data-ezink-design-art]");
    var wrap = item.querySelector("[data-ezink-design-artwrap]");
    var warp = item.querySelector("[data-ezink-design-warp]");
    if (!garment || !art || !wrap) return null;
    if (wrap.hidden || !art.getAttribute("src") || !garment.naturalWidth) return null;
    var gRect = garment.getBoundingClientRect();
    if (!gRect.width || !gRect.height) return null;
    var warped = !!(wrap.classList.contains("is-warped") && warp && !warp.hidden);
    var visual = warped ? warp : art;
    var aRect = visual.getBoundingClientRect();
    var theta = parseFloat(wrap.getAttribute("data-ezink-warp-theta") || "");
    if (!(theta > 0)) theta = 0;
    return {
      item: item,
      garment: garment,
      art: art,
      warped: warped,
      theta: theta,
      rx: (aRect.left - gRect.left) / gRect.width,
      ry: (aRect.top - gRect.top) / gRect.height,
      rw: aRect.width / gRect.width,
      rh: aRect.height / gRect.height
    };
  }

  function loadCorsImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (/^https?:/i.test(url) || url.indexOf("//") === 0) img.crossOrigin = "anonymous";
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error("image")); };
      img.src = url;
    });
  }

  function artIsSvg(item, art) {
    var inp = item && item.querySelector && item.querySelector("[data-ezink-file]");
    var file = inp && inp.files && inp.files[0];
    if (file) {
      var name = String(file.name || "").toLowerCase();
      var type = String(file.type || "").toLowerCase();
      return /\.svg$/.test(name) || type.indexOf("svg") >= 0;
    }
    var src = (art && (art.currentSrc || art.getAttribute("src"))) || "";
    return /\.svg(\?|#|$)/i.test(src) || src.indexOf("image/svg") >= 0;
  }

  function rasterSvg(src, w, h) {
    return fetch(src).then(function (res) { return res.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, "image/svg+xml");
      var svg = doc.documentElement;
      if (!svg || String(svg.nodeName || "").toLowerCase() !== "svg") throw new Error("svg");
      if (!svg.getAttribute("viewBox")) {
        var ow = parseFloat(svg.getAttribute("width")) || 0;
        var oh = parseFloat(svg.getAttribute("height")) || 0;
        if (ow > 0 && oh > 0) svg.setAttribute("viewBox", "0 0 " + ow + " " + oh);
      }
      svg.setAttribute("width", String(Math.max(1, Math.round(w))));
      svg.setAttribute("height", String(Math.max(1, Math.round(h))));
      var xml = new XMLSerializer().serializeToString(svg);
      var blob = new Blob([xml], { type: "image/svg+xml" });
      var url = URL.createObjectURL(blob);
      return loadCorsImage(url).then(function (img) {
        URL.revokeObjectURL(url);
        return img;
      }, function (err) {
        URL.revokeObjectURL(url);
        throw err;
      });
    });
  }

  function canvasZoomUrl(canvas) {
    return new Promise(function (resolve) {
      try {
        if (canvas.toBlob) {
          canvas.toBlob(function (blob) {
            if (blob) {
              resolve(URL.createObjectURL(blob));
              return;
            }
            try { resolve(canvas.toDataURL("image/jpeg", 0.92)); } catch (err) { resolve(""); }
          }, "image/jpeg", 0.92);
          return;
        }
        resolve(canvas.toDataURL("image/jpeg", 0.92));
      } catch (err) {
        resolve("");
      }
    });
  }

  /* Captures placement while the stage is on screen, then draws the largest
     garment rendition. Called before the design box closes. */
  function apparelSnapshotZoom(item) {
    var layout = snapshotLayout(item);
    if (!layout) return Promise.resolve("");
    var current = layout.garment.currentSrc || layout.garment.src || "";
    var zoomUrl = shopifyZoomUrl(current, ZOOM_LONG_EDGE);
    var garmentJob = zoomUrl
      ? loadCorsImage(zoomUrl).catch(function () { return layout.garment; })
      : Promise.resolve(layout.garment);
    return garmentJob.then(function (garmentImg) {
      if (!garmentImg || garmentImg.naturalWidth + 1 < layout.garment.naturalWidth) garmentImg = layout.garment;
      var size = zoomCanvasSize(garmentImg.naturalWidth, garmentImg.naturalHeight, ZOOM_LONG_EDGE);
      var dw = layout.rw * size.w;
      var dh = layout.rh * size.h;
      var artJob = (artIsSvg(layout.item, layout.art) && dw > 1 && dh > 1)
        ? rasterSvg(layout.art.getAttribute("src") || layout.art.src, dw, dh).catch(function () { return layout.art; })
        : Promise.resolve(layout.art);
      return artJob.then(function (artImg) {
        try {
          if (!(size.w > 0) || !(size.h > 0)) return "";
          var canvas = document.createElement("canvas");
          canvas.width = size.w;
          canvas.height = size.h;
          var ctx = canvas.getContext("2d");
          ctx.imageSmoothingEnabled = true;
          if (ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = "high";
          ctx.fillStyle = "#111";
          ctx.fillRect(0, 0, size.w, size.h);
          ctx.drawImage(garmentImg, 0, 0, size.w, size.h);
          if (!(dw > 1) || !(dh > 1)) return canvasZoomUrl(canvas);
          var dx = layout.rx * size.w;
          var dy = layout.ry * size.h;
          var source = artImg || layout.art;
          if (layout.warped && layout.theta > 0) {
            var warpCanvas = document.createElement("canvas");
            warpCanvas.width = Math.max(2, Math.round(dw));
            warpCanvas.height = Math.max(2, Math.round(dh));
            paintWarp(warpCanvas, source, layout.theta);
            ctx.drawImage(warpCanvas, dx, dy);
          } else {
            ctx.drawImage(source, dx, dy, dw, dh);
          }
          return canvasZoomUrl(canvas);
        } catch (err) {
          return "";
        }
      });
    }).catch(function () { return ""; });
  }

  function paintWearPreview(item, box) {
    var frame = box.querySelector("[data-ezink-art-summary-wear]");
    var img = box.querySelector("[data-ezink-art-summary-wear-img]");
    if (!frame || !img) return;
    var src = item.__ezinkApparelUrl || "";
    if (!src) {
      var proof = item.querySelector("[data-ezink-design-thumb]");
      if (proof && proof.getAttribute("src")) src = proof.getAttribute("src");
    }
    var composite = frame.querySelector("[data-ezink-art-summary-composite]");
    if (src) {
      if (composite) composite.remove();
      paintSummaryImg(img, src, "On the shirt");
      frame.hidden = false;
      return;
    }
    paintSummaryImg(img, "", "");
    var garment = item.querySelector("[data-ezink-design-garment]");
    var art = item.querySelector("[data-ezink-design-art]");
    var wrap = item.querySelector("[data-ezink-design-artwrap]");
    var fit = item.querySelector("[data-ezink-design-fit]");
    var area = item.querySelector("[data-ezink-design-box]");
    var gSrc = garment && garment.getAttribute("src");
    var aSrc = art && art.getAttribute("src");
    if (!gSrc || !aSrc || (wrap && wrap.hidden)) {
      if (composite) composite.remove();
      frame.hidden = true;
      return;
    }
    if (!composite) {
      composite = document.createElement("span");
      composite.className = "ezink-art-summary__composite";
      composite.setAttribute("data-ezink-art-summary-composite", "");
      frame.appendChild(composite);
    }
    var fitW = (fit && fit.style.width) || "100%";
    var boxStyle = area ? area.getAttribute("style") || "" : "";
    var wrapStyle = wrap ? wrap.getAttribute("style") || "" : "";
    composite.innerHTML =
      '<span class="ezink-art-summary__fit" style="width:' + String(fitW).replace(/"/g, "") + '">' +
      '<img alt="" src="' + String(gSrc).replace(/"/g, "&quot;") + '">' +
      '<span class="ezink-art-summary__box" style="' + String(boxStyle).replace(/"/g, "&quot;") + '">' +
      '<img alt="On the shirt" style="' + String(wrapStyle).replace(/"/g, "&quot;") + '" src="' + String(aSrc).replace(/"/g, "&quot;") + '">' +
      "</span></span>";
    frame.hidden = false;
  }

  function printTypeLabel(item) {
    if (!item || !item.querySelector) return "";
    var sel = item.querySelector("[data-ezink-art-transfer]");
    var opt = sel && sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
    var text = opt ? String(opt.text || "").replace(/\s+/g, " ").trim() : "";
    if (text) return text;
    var field = item.querySelector("[data-ezink-art-transfer-field]");
    return field ? String(field.value || "").replace(/\s+/g, " ").trim() : "";
  }

  function tieFields(item, form) {
    if (!item || !form || !item.querySelectorAll) return;
    var id = form.getAttribute("id") || "";
    if (!id) return;
    item.querySelectorAll("input, select, textarea").forEach(function (el) {
      el.setAttribute("form", id);
    });
  }

  function ensureModal() {
    var modal = document.querySelector("[data-ezink-dlab-modal]");
    if (modal) return modal;
    modal = document.createElement("div");
    modal.className = "ezink-dlab-modal";
    modal.setAttribute("data-ezink-dlab-modal", "");
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ezink-dlab-modal__backdrop" data-ezink-dlab-close></div>' +
      '<div class="ezink-dlab-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ezink-dlab-modal-title">' +
      '<div class="ezink-dlab-modal__bar">' +
      '<h2 id="ezink-dlab-modal-title" class="ezink-dlab-modal__title">Design</h2>' +
      '<button type="button" class="ezink-dlab-modal__x" data-ezink-dlab-close aria-label="Close">&times;</button>' +
      "</div>" +
      '<div class="ezink-dlab-modal__body" data-ezink-dlab-body></div>' +
      '<div class="ezink-dlab-modal__footer">' +
      '<button type="button" class="ezink-dlab-modal__done" data-ezink-dlab-done>Done</button>' +
      "</div></div>";
    document.body.appendChild(modal);
    modal.addEventListener("click", function (evt) {
      var hit = evt.target && evt.target.closest && evt.target.closest("[data-ezink-dlab-done], [data-ezink-dlab-close]");
      if (!hit || !modal.contains(hit)) return;
      evt.preventDefault();
      closeStudio();
    });
    return modal;
  }

  var STUDIO_CONTROLS = [
    ".ezink-art-item__bar",
    ".ezink-art-item__file",
    ".ezink-art__drop",
    "[data-ezink-art-cloud]",
    ".ezink-art-item__fields",
    ".ezink-dlab__resize-hint",
    ".ezink-dlab__warn",
    ".ezink-dlab__hint",
    ".ezink-dlab__note",
    ".ezink-art-item__extras"
  ];

  function parkNode(el, home) {
    if (!el || !home || !el.parentNode || el.parentNode === home) return;
    var mark = document.createComment("ezink-studio");
    el.parentNode.insertBefore(mark, el);
    el.__ezinkMark = mark;
    home.appendChild(el);
  }

  function restoreNode(el) {
    var mark = el && el.__ezinkMark;
    if (mark && mark.parentNode) {
      mark.parentNode.insertBefore(el, mark);
      mark.remove();
    }
    if (el) el.__ezinkMark = null;
  }

  function splitStudio(item) {
    if (!item || item.querySelector("[data-ezink-studio-split]")) return;
    var split = document.createElement("div");
    split.className = "ezink-studio-split";
    split.setAttribute("data-ezink-studio-split", "");
    var controls = document.createElement("div");
    controls.className = "ezink-studio-controls";
    controls.setAttribute("data-ezink-studio-controls", "");
    var preview = document.createElement("div");
    preview.className = "ezink-studio-preview";
    preview.setAttribute("data-ezink-studio-preview", "");
    split.appendChild(controls);
    split.appendChild(preview);
    var stage = item.querySelector(".ezink-dlab__stage");
    if (stage) parkNode(stage, preview);
    var i;
    for (i = 0; i < STUDIO_CONTROLS.length; i++) {
      var el = item.querySelector(STUDIO_CONTROLS[i]);
      if (el) parkNode(el, controls);
    }
    item.appendChild(split);
  }

  function unsplitStudio(item) {
    if (!item) return;
    var split = item.querySelector("[data-ezink-studio-split]");
    if (!split) return;
    var moved = split.querySelectorAll("[data-ezink-studio-controls] > *, [data-ezink-studio-preview] > *");
    var i;
    for (i = 0; i < moved.length; i++) restoreNode(moved[i]);
    split.remove();
  }

  function closeStudio() {
    var item = studio.item;
    var modal = document.querySelector("[data-ezink-dlab-modal]");
    var opener = studio.opener;
    if (item) {
      var host = item.querySelector("[data-ezink-design]");
      if (host && host._ezinkCommit) host._ezinkCommit();
      var png = apparelSnapshot(item);
      if (png) item.__ezinkApparelUrl = png;
      if (item.__ezinkZoomUrl && String(item.__ezinkZoomUrl).indexOf("blob:") === 0) {
        try { URL.revokeObjectURL(item.__ezinkZoomUrl); } catch (err) {}
      }
      item.__ezinkZoomUrl = "";
      var zoomJob = apparelSnapshotZoom(item);
      item.__ezinkZoomJob = zoomJob;
      zoomJob.then(function (url) {
        if (item.__ezinkZoomJob !== zoomJob) {
          if (url && String(url).indexOf("blob:") === 0) {
            try { URL.revokeObjectURL(url); } catch (err) {}
          }
          return;
        }
        if (url) item.__ezinkZoomUrl = url;
      });
      unsplitStudio(item);
      var panel = item.querySelector("[data-ezink-design-panel]");
      if (panel) panel.hidden = true;
      var openBtn = item.querySelector("[data-ezink-design-open]");
      if (openBtn) openBtn.setAttribute("aria-expanded", "false");
      if (studio.homeParent) {
        if (studio.homeNext && studio.homeNext.parentNode === studio.homeParent) {
          studio.homeParent.insertBefore(item, studio.homeNext);
        } else {
          studio.homeParent.appendChild(item);
        }
      }
      item.classList.add("is-collapsed");
      paintArtSummary(item);
    }
    if (modal) modal.hidden = true;
    unlockScroll();
    studio.item = null;
    studio.homeParent = null;
    studio.homeNext = null;
    studio.opener = null;
    var edit = item && item.querySelector("[data-ezink-art-edit]");
    if (opener && document.contains(opener) && opener.offsetParent !== null) opener.focus();
    else if (edit) edit.focus();
  }

  /* The design box moves the artwork row into the modal, so closest()
     no longer finds the product. homeParent is where that row came from. */
  function productArtRoot(item) {
    var found = item && item.closest && item.closest("[data-ezink-art-pdp]");
    if (found) return found;
    var home = studio && studio.homeParent;
    if (home) {
      if (home.getAttribute && home.getAttribute("data-ezink-art-pdp") != null) return home;
      if (home.closest) {
        found = home.closest("[data-ezink-art-pdp]");
        if (found) return found;
      }
    }
    return document.querySelector("[data-ezink-art-pdp]");
  }

  function openStudio(item, opener) {
    if (!item) return;
    var pdp = (item.closest && item.closest("[data-ezink-art-pdp]")) || document.querySelector("[data-ezink-art-pdp]");
    if (isTarget(pdp)) ensure(item);
    var form = (item.closest && item.closest("form")) || document.querySelector("form[action*='/cart/add']") || document.body;
    var modal = ensureModal();
    tieFields(item, form);
    if (studio.item === item && modal && !modal.hidden) return;
    if (studio.item && studio.item !== item) closeStudio();
    var body = modal.querySelector("[data-ezink-dlab-body]");
    studio.homeParent = item.parentNode;
    studio.homeNext = item.nextSibling;
    studio.item = item;
    studio.opener = opener || document.activeElement;
    item.classList.remove("is-collapsed");
    var panel = item.querySelector("[data-ezink-design-panel]");
    if (panel) panel.hidden = false;
    var openBtn = item.querySelector("[data-ezink-design-open]");
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    if (body) body.appendChild(item);
    var title = modal.querySelector("#ezink-dlab-modal-title");
    if (title) title.textContent = item.getAttribute("data-art-label") || "Design";
    modal.hidden = false;
    lockScroll();
    splitStudio(item);
    var host = item.querySelector("[data-ezink-design]");
    if (host && host._ezinkLayout) host._ezinkLayout();
    var x = modal.querySelector(".ezink-dlab-modal__x");
    if (x) x.focus();
  }

  function onStudioKey(evt) {
    var modal = document.querySelector("[data-ezink-dlab-modal]");
    if (!modal || modal.hidden) return;
    if (evt.key === "Escape") {
      var zoom = document.getElementById("ezink-art-modal");
      if (zoom && !zoom.hidden) return;
      evt.preventDefault();
      evt.stopPropagation();
      closeStudio();
      return;
    }
    if (evt.key !== "Tab") return;
    var dialog = modal.querySelector(".ezink-dlab-modal__dialog");
    var list = focusables(dialog);
    if (!list.length) {
      evt.preventDefault();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (evt.shiftKey && (active === first || !dialog.contains(active))) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && (active === last || !dialog.contains(active))) {
      evt.preventDefault();
      first.focus();
    }
  }

  if (!root.__ezinkDlabKeys) {
    root.__ezinkDlabKeys = true;
    document.addEventListener("keydown", onStudioKey);
  }

  function openPending() {
    var item = document.querySelector("[data-ezink-art-item][data-ezink-open-next]");
    if (!item) return;
    item.removeAttribute("data-ezink-open-next");
    openStudio(item, null);
  }

  function ensure(item) {
    if (!item || item.querySelector("[data-ezink-design]")) return;
    var host = document.createElement("div");
    host.className = "ezink-dlab";
    host.setAttribute("data-ezink-design", "");
    host.innerHTML =
      '<button type="button" class="ezink-dlab__open" data-ezink-design-open data-ezink-spot="customize" aria-expanded="false">Design it</button>' +
      '<div class="ezink-dlab__panel" data-ezink-design-panel hidden>' +
      '<div class="ezink-dlab__stage">' +
      '<p class="ezink-dlab__approx-note" data-ezink-approx-note>' + APPROX_NOTE + "</p>" +
      '<span class="ezink-dlab__approx" data-ezink-design-approx hidden>Approximate</span>' +
      '<div class="ezink-dlab__fit" data-ezink-design-fit>' +
      '<img class="ezink-dlab__garment" alt="" data-ezink-design-garment>' +
      '<span class="ezink-dlab__axis" data-ezink-design-axis hidden></span>' +
      '<div class="ezink-dlab__box" data-ezink-design-box>' +
      '<div class="ezink-dlab__artwrap" data-ezink-design-artwrap data-ezink-spot="placement" hidden>' +
      '<span class="ezink-dlab__readout" data-ezink-design-readout hidden></span>' +
      '<img class="ezink-dlab__art" alt="" draggable="false" data-ezink-design-art>' +
      '<canvas class="ezink-dlab__warp" data-ezink-design-warp hidden></canvas>' +
      '<button type="button" class="ezink-dlab__handle" data-ezink-design-handle aria-label="Drag to resize" title="Drag to resize"></button>' +
      "</div>" +
      "</div></div></div>" +
      '<p class="ezink-dlab__resize-hint">Drag to resize</p>' +
      '<p class="ezink-dlab__warn" data-ezink-design-dpi hidden></p>' +
      '<p class="ezink-dlab__hint">Vector preferred (SVG, AI, EPS, or PDF), or a high-res transparent PNG. Use the upload below. It is the file on the order.</p>' +
      '<p class="ezink-dlab__note" data-ezink-design-note hidden></p>' +
      "</div>";
    var drop = item.querySelector(".ezink-art__drop");
    if (drop) item.insertBefore(host, drop);
    else item.appendChild(host);
    bind(host, item);
  }

  function bind(host, item) {
    var panel = host.querySelector("[data-ezink-design-panel]");
    var openBtn = host.querySelector("[data-ezink-design-open]");
    var stage = host.querySelector(".ezink-dlab__stage");
    var resizeHint = host.querySelector(".ezink-dlab__resize-hint");
    var badge = host.querySelector("[data-ezink-design-approx]");
    var box = host.querySelector("[data-ezink-design-box]");
    var garment = host.querySelector("[data-ezink-design-garment]");
    var wrap = host.querySelector("[data-ezink-design-artwrap]");
    var art = host.querySelector("[data-ezink-design-art]");
    var handle = host.querySelector("[data-ezink-design-handle]");
    var readout = host.querySelector("[data-ezink-design-readout]");
    var note = host.querySelector("[data-ezink-design-note]");
    var file = item.querySelector("[data-ezink-file]");
    var fit = host.querySelector("[data-ezink-design-fit]");
    var axis = host.querySelector("[data-ezink-design-axis]");
    var warp = host.querySelector("[data-ezink-design-warp]");
    var dpiEl = host.querySelector("[data-ezink-design-dpi]");
    var state = {
      x: 50, y: 50, wPct: 80, natW: 0, natH: 0, inchW: 0, pxW: 0, pxH: 0,
      vector: false, previewSize: "", sizes: [],
      area: null, url: "", tintKey: "", tintUrl: "", wantTint: ""
    };
    var gesture = null;
    var writingSize = false;

    function pushLabel(out, seen, raw) {
      var s = String(raw || "").replace(/\s+/g, " ").trim();
      if (!s || seen[s.toUpperCase()]) return;
      seen[s.toUpperCase()] = true;
      out.push(s);
    }

    function productIsYouth(section) {
      var pdp = productArtRoot(item);
      var handle = (pdp && pdp.getAttribute("data-ezink-handle")) || "";
      if (/youth/i.test(handle)) return true;
      var titleEl = section && section.querySelector(".product-single__title");
      if (titleEl && /youth/i.test(titleEl.textContent || "")) return true;
      if (CHART && CHART.XS && CHART.XS.w > 0 && CHART.XS.w <= 15 && !CHART["2XL"] && !CHART["5XL"]) return true;
      return false;
    }

    function sizeLabels(section) {
      var out = [];
      var seen = {};
      if (!section) return out;
      var grid = section.querySelector("[data-ezink-size-qty-grid]");
      var listed = grid && grid.getAttribute("data-ezink-size-options");
      var i;
      if (listed) listed.split("|").forEach(function (part) { pushLabel(out, seen, part); });
      var sel = section.querySelector("[data-ezink-size-select]");
      if (sel && sel.options) {
        for (i = 0; i < sel.options.length; i++) pushLabel(out, seen, sel.options[i].value || sel.options[i].text);
      }
      var inputs = section.querySelectorAll("[data-ezink-size-qty-input]");
      for (i = 0; i < inputs.length; i++) pushLabel(out, seen, inputs[i].getAttribute("data-size") || "");
      return out;
    }

    function loadProductChart() {
      if (CHART) return;
      var table = document.querySelector(".ezink-size-chart");
      if (!table) return;
      var headers = [];
      var rows = [];
      var hs = table.querySelectorAll("thead th");
      var i;
      var c;
      for (i = 0; i < hs.length; i++) headers.push(hs[i].textContent || "");
      var trs = table.querySelectorAll("tbody tr");
      for (i = 0; i < trs.length; i++) {
        var cells = trs[i].querySelectorAll("th, td");
        var row = [];
        for (c = 0; c < cells.length; c++) row.push(cells[c].textContent || "");
        rows.push(row);
      }
      if (headers.length) applySpecChart(headers, rows);
    }

    function sizeIsYouth(size, productYouth) {
      return !!productYouth || /^(YXS|YS|YM|YL|YXL)$/.test(size);
    }

    function setNote(text) {
      if (!note) return;
      note.hidden = !text;
      note.textContent = text || "";
    }

    function pushSizeToForm(fitted) {
      if (!fitted) return;
      var wEl = item.querySelector("[data-ezink-art-w]");
      var hEl = item.querySelector("[data-ezink-art-h]");
      if (!wEl || !hEl) return;
      if (state.area && (state.area.key === "left sleeve" || state.area.key === "right sleeve")) {
        wEl.removeAttribute("max");
        hEl.removeAttribute("max");
      }
      if (wEl.getAttribute("step") === "0.25") wEl.setAttribute("step", "0.1");
      if (hEl.getAttribute("step") === "0.25") hEl.setAttribute("step", "0.1");
      var w = fmtIn(fitted.w);
      var h = fmtIn(fitted.h);
      var active = document.activeElement;
      if (writingSize && active === wEl) w = wEl.value;
      else if (active === wEl && keepTypedInches(wEl.value, fitted.w, w)) w = wEl.value;
      if (writingSize && active === hEl) h = hEl.value;
      else if (active === hEl && keepTypedInches(hEl.value, fitted.h, h)) h = hEl.value;
      if (wEl.value === w && hEl.value === h) return;
      var widthChanged = wEl.value !== w;
      if (wEl.value !== w) wEl.value = w;
      if (hEl.value !== h) hEl.value = h;
      var preset = item.querySelector("[data-ezink-art-size-preset]");
      if (preset && preset.querySelector('option[value="custom"]')) preset.value = "custom";
      if (writingSize || !widthChanged) return;
      try { wEl.dispatchEvent(new Event("input", { bubbles: true })); } catch (err) {}
    }

    function writePlacement() {
      var place = item.querySelector("[data-ezink-art-placement]");
      if (!place) return;
      var sizeTxt = readout && readout.textContent ? String(readout.textContent).trim() : "";
      var loc = locationName(item);
      var next = [loc, sizeTxt, "x " + Math.round(state.x) + "%", "y " + Math.round(state.y) + "%"].filter(Boolean).join(" · ").slice(0, 240);
      place.value = next;
      place.name = next ? ("properties[Placement — " + loc + "]") : "";
    }

    function syncInches(fitted) {
      state.inchW = fitted.w;
      if (state.area && state.area.w > 0) state.wPct = (fitted.w / state.area.w) * 100;
      pushSizeToForm(fitted);
    }

    function applyDpi(hIn) {
      if (!dpiEl) return;
      var msg = state.natW > 0 ? lowResWarning(state.pxW, state.inchW, state.vector) : "";
      if (!msg && state.natW > 0 && hIn > 0) msg = lowResWarning(state.pxH, hIn, state.vector);
      dpiEl.hidden = !msg;
      dpiEl.textContent = msg || "";
    }

    function applyWarp() {
      if (!warp) return;
      var key = state.area ? state.area.key : "";
      var theta = 0;
      if (shouldWarp(key) && state.natW > 0 && art.naturalWidth && state.inchW > 0) {
        theta = warpTheta(state.inchW, bodyFor(state.area.size).w);
      }
      if (!(theta > 0) || wrap.clientWidth < 8 || wrap.clientHeight < 8) {
        wrap.classList.remove("is-warped");
        wrap.removeAttribute("data-ezink-warp-theta");
        warp.hidden = true;
        return;
      }
      var dpr = Math.min((window.devicePixelRatio || 1), 2);
      var w = Math.max(2, Math.round(wrap.clientWidth * dpr));
      var h = Math.max(2, Math.round(wrap.clientHeight * dpr));
      if (warp.width !== w) warp.width = w;
      if (warp.height !== h) warp.height = h;
      try {
        paintWarp(warp, art, theta);
        warp.hidden = false;
        wrap.classList.add("is-warped");
        wrap.setAttribute("data-ezink-warp-theta", String(theta));
      } catch (err) {
        wrap.classList.remove("is-warped");
        wrap.removeAttribute("data-ezink-warp-theta");
        warp.hidden = true;
      }
    }

    function applyArt() {
      if (!state.area) return;
      var sleeve = state.area.key === "left sleeve" || state.area.key === "right sleeve";
      var capW = sleeve ? 0 : state.area.w;
      var capH = sleeve ? 0 : state.area.h;
      var fitted = null;
      var requested = writingSize ? state.inchW : 0;
      if (state.natW > 0 && state.inchW > 0) {
        fitted = fitInches(state.inchW, state.natW, state.natH, capW, capH);
        if (requested > 0) {
          var kept = preserveSpinnerInches(requested, fitted.w);
          if (kept + 1e-9 < fitted.w) {
            var aspect = state.natH > 0 ? state.natW / state.natH : 1;
            fitted = { w: kept, h: kept / aspect };
          }
        }
        syncInches(fitted);
      }
      var boxW = box.clientWidth || 0;
      var boxH = box.clientHeight || 0;
      if (state.natW > 0 && boxW > 0 && boxH > 0) {
        var placed = clampPlacement(boxW, boxH, state.natW, state.natH, state.x, state.y, state.wPct, sleeve);
        state.x = placed.x;
        state.y = placed.y;
        state.wPct = placed.wPct;
        if (state.area.w > 0) {
          var again = (state.wPct / 100) * state.area.w;
          var undoDecrease = writingSize && fitted && again + 1e-6 >= fitted.w;
          if (!undoDecrease) {
            fitted = fitInches(widthInches(state.wPct, state.area.w), state.natW, state.natH, capW, capH);
            syncInches(fitted);
          }
        }
      }
      wrap.style.left = state.x + "%";
      wrap.style.top = state.y + "%";
      wrap.style.width = state.wPct + "%";
      if (state.natW > 0 && fitted) {
        readout.hidden = false;
        readout.textContent = fmtIn(fitted.w) + " in";
        applyDpi(fitted.h);
      } else {
        readout.hidden = true;
        readout.textContent = "";
        applyDpi(0);
      }
      applyWarp();
      writePlacement();
    }

    function setApproximate(on) {
      if (stage) stage.classList.toggle("is-approximate", !!on);
      if (badge) badge.hidden = !on;
      var noteEl = host.querySelector("[data-ezink-approx-note]");
      if (noteEl) noteEl.textContent = on ? SLEEVE_TEMPLATE_NOTE : APPROX_NOTE;
    }

    function showGarment(url, alt, cors) {
      if (!url) {
        state.url = "";
        garment.removeAttribute("src");
        garment.alt = "Garment photo unavailable";
        return;
      }
      if (url === state.url) {
        garment.alt = alt;
        return;
      }
      state.url = url;
      garment.alt = alt;
      garment.onerror = function () {
        garment.onerror = null;
        if (garment.crossOrigin) {
          garment.removeAttribute("crossorigin");
          garment.src = url;
        }
      };
      if (cors && /^https?:/i.test(url)) garment.crossOrigin = "anonymous";
      else garment.removeAttribute("crossorigin");
      garment.onload = function () { applyArt(); };
      garment.src = url;
    }

    function paintTemplate(tmpl, hex, mid) {
      mid = mid || 208;
      var key = tmpl.url + "|" + (hex || "");
      state.wantTint = key;
      if (!hex) {
        showGarment(tmpl.url, "Approximate sleeve", true);
        return;
      }
      if (state.tintKey === key && state.tintUrl) {
        showGarment(state.tintUrl, "Approximate sleeve", false);
        return;
      }
      var probe = new Image();
      probe.crossOrigin = "anonymous";
      probe.onload = function () {
        if (state.wantTint !== key) return;
        var tinted = "";
        try {
          tinted = tintImage(probe, hex, mid);
        } catch (err) {
          tinted = "";
        }
        if (state.wantTint !== key) return;
        if (!tinted) {
          showGarment(tmpl.url, "Approximate sleeve", true);
          return;
        }
        state.tintKey = key;
        state.tintUrl = tinted;
        showGarment(tinted, "Approximate sleeve", false);
      };
      probe.onerror = function () {
        if (state.wantTint !== key) return;
        showGarment(tmpl.url, "Approximate sleeve", true);
      };
      probe.src = tmpl.url;
    }

    /* Named 64000 colors keep their list hex. Everyone else gets the
       center of that color's front photo, then the swatch stores it. */
    function applySleeveTint(section, color, tmpl, mid) {
      var hex = selectedHex(section, color);
      if (hex) {
        paintTemplate(tmpl, hex, mid);
        return;
      }
      var front = absUrl(pickMedia(section, color, "front"));
      var token = "sample|" + (tmpl.url || "") + "|" + front + "|" + String(color || "");
      state.wantTint = token;
      if (front && frontHexByUrl[front]) {
        writeSwatchHex(section, color, frontHexByUrl[front]);
        paintTemplate(tmpl, frontHexByUrl[front], mid);
        return;
      }
      showGarment(tmpl.url, "Approximate sleeve", true);
      if (!front) return;
      var probe = new Image();
      probe.crossOrigin = "anonymous";
      probe.onload = function () {
        if (state.wantTint !== token) return;
        var sampled = "";
        try {
          sampled = sampleImageCenter(probe);
        } catch (err) {
          sampled = "";
        }
        if (state.wantTint !== token) return;
        if (!sampled) return;
        frontHexByUrl[front] = sampled;
        writeSwatchHex(section, color, sampled);
        paintTemplate(tmpl, sampled, mid);
      };
      probe.onerror = function () {
        if (state.wantTint !== token) return;
      };
      probe.src = front;
    }

    function readFieldInches(which) {
      var wEl = item.querySelector("[data-ezink-art-w]");
      var hEl = item.querySelector("[data-ezink-art-h]");
      return inchesFromSizeFields(
        wEl && wEl.value,
        hEl && hEl.value,
        which || "w",
        state.natW,
        state.natH
      );
    }

    function applyTypedInches(which) {
      var inchW = readFieldInches(which);
      if (!(inchW > 0)) return;
      if (Math.abs(state.inchW - inchW) < 1e-6) return;
      state.inchW = inchW;
      if (state.natW > 0 && wrap.hidden) wrap.hidden = false;
      writingSize = true;
      try { applyArt(); }
      finally { writingSize = false; }
    }

    function layout() {
      loadProductChart();
      var section = sectionOf(item);
      var youthProduct = productIsYouth(section);
      state.youth = youthProduct;
      var sizes = offeredSizes(sizeLabels(section), youthProduct);
      if (!sizes.length) {
        sizes = offeredSizes(
          youthProduct ? ["XS", "S", "M", "L", "XL"] : ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
          youthProduct
        );
      }
      state.sizes = sizes;
      if (!state.previewSize || sizes.indexOf(state.previewSize) < 0) {
        state.previewSize = defaultPreviewSize(sizes);
      }
      var area = printArea(state.previewSize, locationName(item), { youth: sizeIsYouth(state.previewSize, youthProduct) });
      state.area = area;
      var body = bodyFor(area.size);
      var side = area.key === "left sleeve" ? "left" : area.key === "right sleeve" ? "right" : "";
      var color = selectedColor(section);
      var media = colorMedia(section, color);
      var pdp = productArtRoot(item);
      var style = styleHandle(pdp);
      var tags = pdp && pdp.getAttribute ? pdp.getAttribute("data-ezink-tags") : "";
      var choice = side ? chooseSleeve(style, side, media.views, tags) : { kind: "none" };
      var sleeveStyle = (choice && choice.style) || style;
      var geom = side && choice.kind !== "none" ? sleeveGeom(sleeveStyle, side, choice.kind) : null;
      var approximate = choice.kind === "template";
      if (fit) {
        var ref = referenceWidth(sizes);
        var scale = side ? 1 : shirtScale(body.w, ref);
        fit.style.width = (Math.round(scale * 1000) / 10) + "%";
      }
      if (geom) {
        var placed = sleeveBox(area.size, area.w, area.h, geom);
        box.style.width = placed.widthPct + "%";
        box.style.left = placed.left + "%";
        box.style.top = placed.top + "%";
      } else {
        var anchor = ANCHOR[area.anchor] || ANCHOR.front;
        var chest = photoChest(body) || body.w;
        var widthPct = (area.w / chest) * TORSO_FRAC * 100;
        box.style.width = widthPct + "%";
        box.style.left = (anchor.cx - widthPct / 2) + "%";
        box.style.top = anchor.top + "%";
      }
      box.style.aspectRatio = area.w + " / " + area.h;
      setApproximate(approximate);
      if (choice.kind === "photo") {
        state.wantTint = "";
        showGarment(media.urls[choice.view] || "", (color || "Garment") + " " + (choice.view || "side"), true);
      } else if (choice.kind === "template") {
        var tmpl = SLEEVE_STYLES[sleeveStyle] && SLEEVE_STYLES[sleeveStyle][side];
        if (tmpl) applySleeveTint(section, color, tmpl, (SLEEVE_STYLES[sleeveStyle] && SLEEVE_STYLES[sleeveStyle].shadeMid) || 208);
        else showGarment("", "", false);
      } else {
        state.wantTint = "";
        showGarment(pickMedia(section, color, area.view), (color || "Garment") + " " + area.view, true);
      }
      requestAnimationFrame(applyArt);
    }

    host._ezinkCommit = writePlacement;
    host._ezinkPark = function () {
      if (studio.item === item) closeStudio();
      panel.hidden = true;
      openBtn.setAttribute("aria-expanded", "false");
    };

    openBtn.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      openStudio(item, openBtn);
    });

    var locSel = item.querySelector("[data-ezink-art-loc]");
    if (locSel) locSel.addEventListener("change", function () {
      if (!panel.hidden) layout();
    });

    function onOrderFile() {
      var picked = file && file.files && file.files[0];
      if (!picked) {
        wrap.hidden = true;
        art.removeAttribute("src");
        state.natW = 0;
        state.pxW = 0;
        state.pxH = 0;
        if (readout) {
          readout.hidden = true;
          readout.textContent = "";
        }
        return;
      }
      var name = String(picked.name || "").toLowerCase();
      var previewable = /\.(svg|png|jpe?g|webp)$/.test(name) || /^image\/(png|jpeg|webp|svg\+xml)/.test(picked.type || "");
      if (!previewable) {
        setNote("Preview needs an SVG or a high-res transparent PNG. AI, EPS, and PDF stay on the order.");
        wrap.hidden = true;
        return;
      }
      setNote("");
      state.vector = /\.svg$/.test(name) || String(picked.type || "").indexOf("svg") >= 0;
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = URL.createObjectURL(picked);
      var probe = new Image();
      probe.onload = function () {
        state.natW = probe.naturalWidth || probe.width || 300;
        state.natH = probe.naturalHeight || probe.height || 300;
        state.pxW = state.vector ? 0 : (probe.naturalWidth || 0);
        state.pxH = state.vector ? 0 : (probe.naturalHeight || 0);
        state.x = garmentCenterX(state.previewSize || "M", locationName(item));
        state.y = 45;
        if (!(state.inchW > 0) && state.area) state.inchW = state.area.w * 0.8;
        art.src = state.objectUrl;
        wrap.hidden = false;
        applyArt();
      };
      probe.onerror = function () {
        setNote("That file did not open in the browser. Use an SVG or a transparent PNG for the preview.");
      };
      probe.src = state.objectUrl;
    }
    if (file) {
      file.addEventListener("change", onOrderFile);
      if (file.files && file.files[0]) onOrderFile();
    }

    function pointBox(evt) {
      var rect = box.getBoundingClientRect();
      return {
        rect: rect,
        px: rect.width ? ((evt.clientX - rect.left) / rect.width) * 100 : 50,
        py: rect.height ? ((evt.clientY - rect.top) / rect.height) * 100 : 50
      };
    }

    wrap.addEventListener("pointerdown", function (evt) {
      if (wrap.hidden) return;
      evt.preventDefault();
      evt.stopPropagation();
      var scaling = evt.target === handle || (evt.target.closest && evt.target.closest("[data-ezink-design-handle]"));
      var p = pointBox(evt);
      gesture = {
        mode: scaling ? "scale" : "move",
        ox: p.px - state.x,
        oy: p.py - state.y,
        wPct: state.wPct,
        dist: Math.hypot(evt.clientX - (p.rect.left + p.rect.width * state.x / 100), evt.clientY - (p.rect.top + p.rect.height * state.y / 100)) || 1
      };
      try { wrap.setPointerCapture(evt.pointerId); } catch (err) {}
    });
    wrap.addEventListener("pointermove", function (evt) {
      if (!gesture) return;
      var p = pointBox(evt);
      if (gesture.mode === "move") {
        state.x = p.px - gesture.ox;
        state.y = p.py - gesture.oy;
        var center = garmentCenterX(state.previewSize || "M", locationName(item));
        var band = state.area ? snapBandPct(state.area.w) : 3;
        if (Math.abs(state.x - center) <= band) {
          state.x = center;
          if (axis && state.area && state.area.key.indexOf("sleeve") < 0) axis.hidden = false;
        } else if (axis) axis.hidden = true;
      } else {
        var cx = p.rect.left + p.rect.width * state.x / 100;
        var cy = p.rect.top + p.rect.height * state.y / 100;
        var dist = Math.hypot(evt.clientX - cx, evt.clientY - cy);
        state.wPct = gesture.wPct * (dist / gesture.dist);
        if (state.area && state.area.w > 0) state.inchW = widthInches(state.wPct, state.area.w);
      }
      applyArt();
    });
    function endGesture() {
      gesture = null;
      if (axis) axis.hidden = true;
    }
    wrap.addEventListener("pointerup", endGesture);
    wrap.addEventListener("pointercancel", endGesture);

    host._ezinkApplyInches = applyTypedInches;
    host._ezinkLayout = layout;
    if (!panel.hidden) layout();
  }

  function scan() {
    var pdps = document.querySelectorAll("[data-ezink-art-pdp]");
    pdps.forEach(function (pdp) {
      if (!isTarget(pdp)) return;
      pdp.querySelectorAll("[data-ezink-art-item]").forEach(ensure);
    });
  }

  function relayoutOpen() {
    document.querySelectorAll("[data-ezink-design-panel]:not([hidden])").forEach(function (panel) {
      var host = panel.closest("[data-ezink-design]");
      if (host && host._ezinkLayout) host._ezinkLayout();
    });
  }

  api.scan = scan;

  document.addEventListener("ezink-art-items-change", function () {
    setTimeout(function () {
      scan();
      openPending();
    }, 0);
  });
  document.addEventListener("ezink-ink-detected", function (evt) {
    var item = evt.detail && evt.detail.item;
    if (!item || !item.classList || !item.classList.contains("is-collapsed")) return;
    paintArtSummary(item);
  });
  document.addEventListener("click", function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var edit = t.closest("[data-ezink-art-edit]");
    if (edit) {
      evt.preventDefault();
      var edited = edit.closest("[data-ezink-art-item]");
      if (edited) openStudio(edited, edit);
      return;
    }
    if (t.closest("[data-ezink-art-add]")) setTimeout(function () {
      scan();
      openPending();
    }, 0);
    if (t.closest(".ezink-pdp-swatch, [data-ezink-color-select]")) setTimeout(relayoutOpen, 60);
  });
  document.addEventListener("click", function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var rm = t.closest(".ezink-art-item__remove");
    if (!rm) return;
    var item = rm.closest("[data-ezink-art-item]");
    var host = item && item.querySelector("[data-ezink-design]");
    if (host && host._ezinkPark) host._ezinkPark(false);
  }, true);
  function applySizeField(node) {
    if (!node || !node.closest) return;
    var row = node.closest("[data-ezink-art-item]");
    var host = row && row.querySelector("[data-ezink-design]");
    if (!host || !host._ezinkApplyInches) return;
    var which = node.matches && node.matches("[data-ezink-art-h]") ? "h" : "w";
    host._ezinkApplyInches(which);
  }

  document.addEventListener("input", function (evt) {
    var t = evt.target;
    if (t && t.matches && t.matches("[data-ezink-size-qty-input]")) relayoutOpen();
    if (t && t.matches && t.matches("[data-ezink-art-w], [data-ezink-art-h]")) applySizeField(t);
  });
  document.addEventListener("change", function (evt) {
    var t = evt.target;
    if (!t || !t.matches) return;
    if (t.matches("[data-ezink-art-loc], [data-ezink-color-select], [data-ezink-size-qty-input]")) {
      setTimeout(relayoutOpen, 0);
    }
    if (t.matches("[data-ezink-art-loc], [data-ezink-art-size-preset]")) applySizeField(t);
  });

  window.addEventListener("resize", function () { relayoutOpen(); });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
})(typeof window !== "undefined" ? window : globalThis);
